import { render, staticRenderFns } from "./kaliteGuvence.vue?vue&type=template&id=509e944a&scoped=true&"
import script from "./kaliteGuvence.vue?vue&type=script&lang=js&"
export * from "./kaliteGuvence.vue?vue&type=script&lang=js&"
import style0 from "./kaliteGuvence.vue?vue&type=style&index=0&id=509e944a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509e944a",
  null
  
)

export default component.exports